"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = HijackAnalysisEngine;

var _react = _interopRequireWildcard(require("react"));

var _tools = require("./utils/tools");

var _helper = require("./utils/helper");

var _render = require("./render");

var _excluded = ["widget", "uuid", "cascadeOn", "childrens", "hidden", "children", "dataBind", "name", "_data"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ComponentRender(props) {
  var _useContext = (0, _react.useContext)(_render.AnalysisEngineContext),
      options = _useContext.options;

  var _ref = options,
      components = _ref.components;

  var widget = props.widget,
      uuid = props.uuid,
      cascadeOn = props.cascadeOn,
      childrens = props.childrens,
      hidden = props.hidden,
      children = props.children,
      dataBind = props.dataBind,
      name = props.name,
      _data = props._data,
      componentProps = _objectWithoutProperties(props, _excluded);

  var Component = (0, _helper.getComponent)(widget, components);

  if (typeof Component === 'undefined') {
    console.error("".concat(widget, " \u4E0D\u5B58\u5728"));
    return children || null;
  }

  return /*#__PURE__*/_react.default.createElement(Component, componentProps, children);
}

var DataRender = /*#__PURE__*/function (_PureComponent) {
  _inherits(DataRender, _PureComponent);

  var _super = _createSuper(DataRender);

  function DataRender() {
    _classCallCheck(this, DataRender);

    return _super.apply(this, arguments);
  }

  _createClass(DataRender, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          data = _this$props.data,
          children = _this$props.children;
      var hidden = data.hidden,
          widget = data.widget,
          wprops = data.wprops;

      if (hidden) {
        return null;
      }

      return /*#__PURE__*/_react.default.createElement(ComponentRender, _extends({
        value: data.value,
        defaultValue: data.defaultValue,
        widget: widget
      }, wprops), children);
    }
  }]);

  return DataRender;
}(_react.PureComponent);
/**
 * 引擎渲染
 * @param {object}     data         数据
 * @param {object}     options      参数
 * @param  {object}    events       回调事件
 * @param  {array}     path         name路径
 * @param  {object}    lifecycle    生命周期
 */


function HijackAnalysisEngine(props) {
  var dataSource = props.dataSource,
      options = props.options,
      propItemRender = props.propItemRender,
      children = props.children; // components undefined

  if (!(0, _tools.isObject)(options)) {
    console.error('options为必填项');
    return null;
  }

  if (!(0, _tools.isObject)(options === null || options === void 0 ? void 0 : options.components)) {
    console.error('options.components为必填项');
    return null;
  }

  return /*#__PURE__*/_react.default.createElement(_render.AnalysisEngineContext.Provider, {
    value: {
      dataSource: dataSource,
      options: options,
      nameMap: {},
      inEngine: true,
      propItemRender: propItemRender,
      moment: {
        current: true
      }
    }
  }, /*#__PURE__*/_react.default.createElement(DataRender, {
    data: dataSource
  }, children));
}